import i18n from '@/i18n'
import { mcToast } from '@/plugins/McToastAlertPlugin'
import store from '@/state/store'
import moment from 'moment'
import Vue from 'vue'
import * as notificationApi from '@/services/rest-api-sms/lib/notification/notification'

export const state = {
  type: null,
  message: null,
  licenseNew: false,
  config: {
    time: {
      key: 10,
      label: '10 Detik',
    },
    alertCodes: [],
    alertSounds: [],
  },
  status: '',
  detailNotification: null,
  listNotificationMedia: null,
  dataDvhRequested: [],
  statusTextVehicleActive: null,
  deviceTypeActive: null,
  popupState: {
    alertCenterPopup: false,
    popupPosition: { x: 100, y: 100 },
  },
  activePopups: [],
  alertList: [],
  newAlertRules: false,
  alertRuleIds: {
    urgentAlertRules: [],
    importantAlertRules: [],
    autoPopupAlertRules: [],
  },
  alertRuleObjs: {},
  notificationRule: null,
  notificationRuleFetchedAt: null,
  notifications: [],
  unreadCount: 0,
  notificationsList: [],    // 📄 untuk HALAMAN LIST
  isRuleFetched: false, // ⬅️ FLAG
}

export const mutations = {
  SET_STATUS(state, payload) {
    state.status = payload
  },
  success(state, message) {
    state.type = 'alert-success'
    state.message = message
  },
  error(state, message) {
    state.type = 'alert-danger'
    state.message = message
  },
  clear(state) {
    state.type = null
    state.message = null
  },
  configPopUp(state, payload) {
    state.config = payload
  },
  setDetailNotification(state, payload) {
    state.detailNotification = payload
  },
  setListNotificationMedia(state, payload) {
    state.listNotificationMedia = payload
  },
  addDataDvhRequested(state, payload) {
    state.dataDvhRequested = [...state.dataDvhRequested, payload]
  },
  updateDataDvhRequested(state, { downloadId, data }) {
    const temp = [...state.dataDvhRequested]
    const index = temp.findIndex((item) => item.downloadId === downloadId)
    if (index !== -1) {
      temp[index] = { ...temp[index], ...data }
      state.dataDvhRequested = temp
    } else {
      // eslint-disable-next-line no-console
      console.warn(`Download ID ${downloadId} not found in dataDvhRequested`)
    }
  },
  resetDataDvhRequested(state) {
    state.dataDvhRequested = []
  },
  setStatusTextVehicleActive(state, payload) {
    state.statusTextVehicleActive = payload
  },
  setDeviceTypeActive(state, payload) {
    state.deviceTypeActive = payload
  },
  setPopupState(state, newState) {
    state.popupState = { ...state.popupState, ...newState }
  },
  ADD_POPUP(state, popup) {
    state.activePopups.push(popup)
    localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
  },
  REMOVE_POPUP(state, alertId) {
    const filteredData = state.activePopups.filter((popup) => popup.alert.id != alertId)
    state.activePopups = filteredData
    localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
  },
  UPDATE_POPUP_POSITION(state, { id, x, y }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.x = x
      popup.y = y
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_MEDIA(state, { id, pollingStatus, canCheck, canRequest, retryCount, videoData }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.pollingStatus = pollingStatus
      popup.alert.videoData = videoData
      popup.alert.canCheck = canCheck
      popup.alert.canRequest = canRequest
      popup.alert.retryCount = retryCount
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  LOAD_POPUPS(state, popups) {
    state.activePopups = popups
  },
  OPEN_POPUP_FORM(state, { id, formOpen }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.formOpen = formOpen
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_FORM(state, { id, formData }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.form = formData
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_FALSE_ALERT(state, { id, lastUserFeedback, isFalseAlert }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.lastUserFeedback = lastUserFeedback
      popup.alert.isFalseAlert = isFalseAlert
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
    const alert = state.alertList.find((alert) => alert.id === id)
    if (alert) {
      alert.lastUserFeedback = lastUserFeedback
      alert.isFalseAlert = isFalseAlert
    }
  },

  // if there will be changes on this function regarding code on the "helper" please also update on helper function groupLogsByDate
  ADD_USER_LOG(state, { id, log }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (!popup) return

    if (!popup.alert.userLogs) {
      Vue.set(popup.alert, 'userLogs', [])
    }

    let allLogs = []
    if (Array.isArray(popup.alert.userLogs)) {
      if (popup.alert.userLogs.length > 0 && popup.alert.userLogs[0].logs) {
        allLogs = popup.alert.userLogs.flatMap((group) => group.logs)
      } else {
        allLogs = [...popup.alert.userLogs]
      }
    }

    allLogs.push(log)

    const grouped = allLogs.reduce((groups, logItem) => {
      const date = moment(logItem.createdOn).format('DD MMM YYYY')
      if (!groups[date]) {
        groups[date] = []
      }
      groups[date].push(logItem)
      return groups
    }, {})

    const sortedLogs = Object.entries(grouped)
      .map(([date, logs]) => ({
        date,
        logs: logs.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)),
      }))
      .sort((a, b) => new Date(b.date) - new Date(a.date))

    Vue.set(popup.alert, 'userLogs', sortedLogs)

    localStorage.setItem('activePopups', JSON.stringify(state.activePopups))

    const alert = state.alertList.find((alert) => alert.id === id)
    if (alert) {
      Vue.set(alert, 'userLogs', sortedLogs)
    }
  },

  SET_ALERT_LIST(state, alerts) {
    state.alertList = alerts
  },
  UPDATE_NOTE_ONLY(state, { id, note, disabledNote }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.note = note
      popup.disabledNote = disabledNote
    }
  },
  UPDATE_FALSE_ALERT(state, { id, lastUserFeedback, isFalseAlert }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.lastUserFeedback = lastUserFeedback
      popup.alert.isFalseAlert = isFalseAlert
    }
  },
  RESET_NOTE_STATE(state, { id }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.note = ''
      popup.disabledNote = false

      if (popup.alert.lastUserFeedback) {
        popup.alert.lastUserFeedback = ''
      }
    }
    const alert = state.alertList.find((alert) => alert.id === id)
    if (alert) {
      alert.lastUserFeedback = ''
    }
  },
  UPDATE_FALSE_ALERT_ONLY(state, { id, lastUserFeedback }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      // Update status false alert tapi pertahankan note dan form
      popup.alert.lastUserFeedback = lastUserFeedback
    }
  },
  UPDATE_POPUP_NOTE(state, { id, note }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.note = note
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  UPDATE_POPUP_RESOLVED(state, { id, isResolved }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.alert.isResolved = isResolved

      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
    const alert = state.alertList.find((alert) => alert.rawAlertId === popup.alert.rawAlertId)

    if (alert) {
      alert.isResolved = isResolved
    }
  },
  UPDATE_ALERT_LIST_RESOLVED(state, { id, isResolved }) {
    const alert = state.alertList.find((alert) => alert.rawAlertId === id)
    if (alert) {
      alert.isResolved = isResolved
    }
  },
  UPDATE_POPUP_RESOLVING(state, { id, isResolving }) {
    const popup = state.activePopups.find((p) => p.id === id)
    if (popup) {
      popup.isResolving = isResolving
      localStorage.setItem('activePopups', JSON.stringify(state.activePopups))
    }
  },
  SET_NEW_ALERT_RULES(state, value) {
    state.newAlertRules = value
  },

  SET_ALERT_RULE_IDS(state, alertRuleIds) {
    state.alertRuleIds = alertRuleIds
  },

  SET_ALERT_RULES_OBJ(state, alertRuleObjs) {
    state.alertRuleObjs = alertRuleObjs
  },

  SET_NOTIFICATION_RULE(state, rule) {
    state.notificationRule = rule
    state.isRuleFetched = true
  },

  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
  },

  SET_NOTIFICATION_MODAL(state, notifications) {
    state.notifications = notifications
  },

  SET_NOTIFICATION_LIST(state, notifications) {
    state.notificationsList = notifications
  },

  SET_UNREAD_COUNT(state, count) {
    state.unreadCount = count
  },

  // ✅ ADD_NOTIFICATION - tambah ke KEDUA array
  ADD_NOTIFICATION(state, notification) {
    // Cek duplikat di kedua array
    const existsInNotifications = state.notifications.some(
      n => n.notification_id === notification.notification_id
    )
    const existsInList = state.notificationsList.some(
      n => n.notification_id === notification.notification_id
    )
    
    if (existsInNotifications || existsInList) return

    // Tambah ke notifications (untuk modal/popup di App.vue)
    state.notifications.unshift(notification)
    
    // Tambah ke notificationsList (untuk halaman list)
    state.notificationsList.unshift(notification)

    // Update unread count
    if (!notification.is_read) {
      state.unreadCount++
    }
  },

  // ✅ MARK_NOTIFICATION_READ - update di KEDUA array
  MARK_NOTIFICATION_READ(state, notificationId) {
    // Update di notifications
    const notif = state.notifications.find(
      n => n.notification_id === notificationId
    )
    if (notif && !notif.is_read) {
      Vue.set(notif, 'is_read', true)
    }

    // Update di notificationsList
    const notifInList = state.notificationsList.find(
      n => n.notification_id === notificationId
    )
    if (notifInList && !notifInList.is_read) {
      Vue.set(notifInList, 'is_read', true)
    }

    state.unreadCount = Math.max(0, state.unreadCount - 1)
  },

  // ✅ MARK_ALL_NOTIFICATIONS_READ - update KEDUA array dengan Vue.set
  MARK_ALL_NOTIFICATIONS_READ(state) {
    // Update notifications array
    state.notifications.forEach(notification => {
      Vue.set(notification, 'is_read', true)
    })

    // Update notificationsList array
    state.notificationsList.forEach(notification => {
      Vue.set(notification, 'is_read', true)
    })

    state.unreadCount = 0
  },
}

export const actions = {
  success({ commit }, message) {
    commit('success', message)
  },
  error({ commit }, message) {
    commit('error', message)
  },
  clear({ commit }) {
    commit('clear')
  },
  addPopup({ commit, state }, { alert, form, formOpen }) {
    const isExists = state.activePopups.some((popup) => popup.alert.id === alert.id)
    if (isExists) return
    if (
      !store.getters['identity/hasAccess'](['e4f-auto-popup-urgent-alert:read']) &&
      state.activePopups.length >= 9
    ) {
      mcToast.warning(i18n.t('notification.text.limitNotification'), { timeout: 1000 })
      return
    }

    const existingAlert = state.alertList.find((a) => a.id === alert.id)
    const userLogs = existingAlert?.userLogs || alert.userLogs || []

    const newPopup = {
      id: alert.id,
      alert: {
        ...alert,
        userLogs: userLogs,
      },
      form,
      formOpen,
      note: '',
      disabledNote: alert.lastUserFeedback ? true : false,
      isResolving: false,
      x: Math.floor(Math.random() * 300),
      y: Math.floor(Math.random() * 300),
    }
    commit('ADD_POPUP', newPopup)
  },
  closePopup({ commit }, alertId) {
    commit('REMOVE_POPUP', alertId)
  },
  updatePosition({ commit }, { id, x, y }) {
    commit('UPDATE_POPUP_POSITION', { id, x, y })
  },
  updateMedia({ commit }, { id, pollingStatus, canCheck, canRequest, retryCount, videoData }) {
    commit('UPDATE_POPUP_MEDIA', {
      id,
      pollingStatus,
      canCheck,
      canRequest,
      retryCount,
      videoData,
    })
  },
  openPopupForm({ commit }, { id, formOpen }) {
    commit('OPEN_POPUP_FORM', { id, formOpen })
  },
  updatePopupForm({ commit }, { id, formData }) {
    commit('UPDATE_POPUP_FORM', { id, formData })
  },
  updatePopupFalseAlert({ commit }, { id, lastUserFeedback, isFalseAlert }) {
    commit('UPDATE_POPUP_FALSE_ALERT', { id, lastUserFeedback, isFalseAlert })
  },
  updatePopupNote({ commit }, { id, note }) {
    commit('UPDATE_POPUP_NOTE', { id, note })
  },
  addUserLog({ commit }, { id, log }) {
    commit('ADD_USER_LOG', { id, log })
  },

  updateFalseAlert({ commit }, payload) {
    commit('UPDATE_FALSE_ALERT', payload)
  },

  resetNoteState({ commit }, payload) {
    commit('RESET_NOTE_STATE', payload)
  },

  updatePopupResolved({ commit }, { id, isResolved }) {
    commit('UPDATE_POPUP_RESOLVED', { id, isResolved })
  },

  updatePopupResolving({ commit }, { id, isResolving }) {
    commit('UPDATE_POPUP_RESOLVING', { id, isResolving })
  },

  showNewAlertRulesToast({ commit }) {
    commit('SET_NEW_ALERT_RULES', true)
  },

  clearNewAlertRulesToast({ commit }) {
    commit('SET_NEW_ALERT_RULES', false)
  },

  updateAlertListResolved({ commit }, { id, isResolved }) {
    commit('UPDATE_ALERT_LIST_RESOLVED', { id, isResolved })
  },

  async fetchNotificationRule({ state, commit }) {
    if (state.isRuleFetched) return // ⛔ STOP DI SINI

    return notificationApi.getNotificationRule().then((res) => {
      if (res.status) {
        commit('SET_NOTIFICATION_RULE', res.data)
      }
      return res
    })
  },

  async fetchNotifications({ commit }, params) {
    const res = await notificationApi.get(params)
    commit('SET_NOTIFICATIONS', res.data?.paginated_result || [])
    return res
  },

  async markNotificationRead({ commit }, notificationId) {
    await notificationApi.markAsRead({ notification_id: notificationId })
    commit('MARK_NOTIFICATION_READ', notificationId)
  },

  async markAllNotificationsRead({ commit }) {
    await notificationApi.markAsRead()
    commit('MARK_ALL_NOTIFICATIONS_READ')
  },

  async fetchUnreadCount({ commit }, userId) {
    const params = {
      filters: [
        `user_id eq ${userId}`,
        `is_read eq false`
      ],
      limit: 1,
      page: 1,
    }
    const res = await notificationApi.get(params)
    commit('SET_UNREAD_COUNT', res.metadata.total_count || 0)
  },
}

export const getters = {
  unreadCount: (state) => state.unreadCount
}
